import { i18n } from 'i18n';

export const COUNTRIES = () => ({
	AF: i18n.t('Афганистан'),
	AL: i18n.t('Албания'),
	DZ: i18n.t('Алжир'),
	AS: i18n.t('American Samoa'),
	AD: i18n.t('Andorra'),
	AO: i18n.t('Angola'),
	AI: i18n.t('Antarctica'),
	AG: i18n.t('Antigua and Barbuda'),
	AR: i18n.t('Argentina'),
	AM: i18n.t('Armenia'),
	AW: i18n.t('Aruba'),
	AU: i18n.t('Australia'),
	AT: i18n.t('Austria'),
	AZ: i18n.t('Azerbaijan'),
	BS: i18n.t(`Bahamas`),
	BH: i18n.t('Bahrain'),
	BD: i18n.t('Bangladesh'),
	BB: i18n.t('Barbados'),
	BY: i18n.t('Belarus'),
	BE: i18n.t('Belgium'),
	BZ: i18n.t('Belize'),
	BJ: i18n.t('Benin'),
	BM: i18n.t('Bermuda'),
	BT: i18n.t('Bhutan'),
	BO: i18n.t('Bolivia (Plurinational State of)'),
	BQ: i18n.t('Bonaire, Sint Eustatius and Saba'),
	BA: i18n.t('Bosnia and Herzegovina'),
	BW: i18n.t('Botswana'),
	BV: i18n.t('Bouvet Island'),
	BR: i18n.t('Brazil'),
	IO: i18n.t('British Indian Ocean Territory'),
	BN: i18n.t('Brunei Darussalam'),
	BG: i18n.t('Bulgaria'),
	BF: i18n.t('Burkina Faso'),
	BI: i18n.t('Burundi'),
	CV: i18n.t('Cabo Verde'),
	KH: i18n.t('Cambodia'),
	CM: i18n.t('Cameroon'),
	CA: i18n.t('Canada'),
	KY: i18n.t('Cayman Islands'),
	CF: i18n.t('Central African Republic'),
	TD: i18n.t('Chad'),
	CL: i18n.t('Chile'),
	CN: i18n.t('China'),
	CX: i18n.t('Christmas Island'),
	CC: i18n.t('Cocos (Keeling) Islands'),
	CO: i18n.t('Colombia'),
	KM: i18n.t('Comoros (the)'),
	CD: i18n.t('Congo (the Democratic Republic of the)'),
	CG: i18n.t('Congo (the)'),
	CK: i18n.t('Cook Islands (the)'),
	CR: i18n.t('Costa Rica'),
	HR: i18n.t('Croatia'),
	CU: i18n.t('Cuba'),
	CW: i18n.t('Curaçao'),
	CY: i18n.t('Cyprus'),
	CZ: i18n.t('Czechia'),
	CI: i18n.t(`Cote d'Ivoire`),
	DK: i18n.t('Denmark'),
	DJ: i18n.t('Djibouti'),
	DM: i18n.t('Dominica'),
	DO: i18n.t('Dominican Republic (the)'),
	EC: i18n.t('Ecuador'),
	EG: i18n.t('Egypt'),
	SV: i18n.t('El Salvador'),
	GQ: i18n.t('Equatorial Guinea'),
	ER: i18n.t('Eritrea'),
	EE: i18n.t('Estonia'),
	SZ: i18n.t('Eswatini'),
	ET: i18n.t('Ethiopia'),
	FK: i18n.t('Falkland Islands (the) [Malvinas]'),
	FO: i18n.t('Faroe Islands (the)'),
	FJ: i18n.t('Fiji'),
	FI: i18n.t('Finland'),
	FR: i18n.t('France'),
	GF: i18n.t('French Guiana'),
	PF: i18n.t('French Polynesia'),
	TF: i18n.t('French Southern Territories (the)'),
	GA: i18n.t('Gabon'),
	GM: i18n.t('Gambia (the)'),
	GE: i18n.t('Georgia'),
	DE: i18n.t('Germany'),
	GH: i18n.t('Ghana'),
	GI: i18n.t('Gibraltar'),
	GR: i18n.t('Greece'),
	GL: i18n.t('Greenland'),
	GD: i18n.t('Grenada'),
	GP: i18n.t('Guadeloupe'),
	GU: i18n.t('Guam'),
	GT: i18n.t('Guatemala'),
	GG: i18n.t('Guernsey'),
	GN: i18n.t('Guinea'),
	GW: i18n.t('Guinea-Bissau'),
	GY: i18n.t('Guyana'),
	HT: i18n.t('Haiti'),
	HM: i18n.t('Heard Island and McDonald Islands'),
	VA: i18n.t('Holy See'),
	HN: i18n.t('Honduras'),
	HK: i18n.t('Hong Kong'),
	HU: i18n.t('Hungary'),
	IS: i18n.t('Iceland'),
	IN: i18n.t('India'),
	ID: i18n.t('Indonesia'),
	IR: i18n.t(`Iran (Islamic Republic of)`),
	IQ: i18n.t('Iraq'),
	IE: i18n.t('Ireland'),
	IM: i18n.t('Isle of Man'),
	IL: i18n.t('Israel'),
	IT: i18n.t('Italy'),
	JM: i18n.t('Jamaica'),
	JP: i18n.t('Japan'),
	JE: i18n.t('Jersey'),
	JO: i18n.t('Jordan'),
	KZ: i18n.t('Kazakhstan'),
	KE: i18n.t('Kenya'),
	KI: i18n.t('Kiribati'),
	KP: i18n.t(`Korea (the Democratic People's Republic of)`),
	KR: i18n.t(`Korea (the Republic of)`),
	KW: i18n.t('Kuwait'),
	KG: i18n.t('Kyrgyzstan'),
	LA: i18n.t(`Lao People's Democratic Republic`),
	LV: i18n.t('Latvia'),
	LB: i18n.t('Lebanon'),
	LS: i18n.t('Lesotho'),
	LR: i18n.t('Liberia'),
	LY: i18n.t('Libya'),
	LI: i18n.t('Liechtenstein'),
	LT: i18n.t('Lithuania'),
	LU: i18n.t('Luxembourg'),
	MO: i18n.t('Macao'),
	MG: i18n.t('Madagascar'),
	MW: i18n.t('Malawi'),
	MY: i18n.t('Malaysia'),
	MV: i18n.t('Maldives'),
	ML: i18n.t('Mali'),
	MT: i18n.t('Malta'),
	MH: i18n.t('Marshall Islands (the)'),
	MQ: i18n.t('Martinique'),
	MR: i18n.t('Mauritania'),
	MU: i18n.t('Mauritius'),
	YT: i18n.t('Mayotte'),
	MX: i18n.t('Mexico'),
	FM: i18n.t('Micronesia (Federated States of)'),
	MD: i18n.t('Moldova (the Republic of)'),
	MC: i18n.t('Monaco'),
	MN: i18n.t('Mongolia'),
	ME: i18n.t('Montenegro'),
	MS: i18n.t('Montserrat'),
	MA: i18n.t('Morocco'),
	MZ: i18n.t('Mozambique'),
	MM: i18n.t('Myanmar'),
	NA: i18n.t('Namibia'),
	NR: i18n.t('Nauru'),
	NP: i18n.t('Nepal'),
	NL: i18n.t('Netherlands'),
	NC: i18n.t('New Caledonia'),
	NZ: i18n.t('New Zealand'),
	NI: i18n.t('Nicaragua'),
	NE: i18n.t('Niger (the)'),
	NG: i18n.t('Nigeria'),
	NU: i18n.t('Niue'),
	NF: i18n.t('Norfolk Island'),
	MP: i18n.t('Northern Mariana Islands'),
	NO: i18n.t('Norway'),
	OM: i18n.t('Oman'),
	PK: i18n.t('Pakistan'),
	PW: i18n.t('Palau'),
	PS: i18n.t('Palestine, State of'),
	PA: i18n.t('Panama'),
	PG: i18n.t('Papua New Guinea'),
	PY: i18n.t('Paraguay'),
	PE: i18n.t('Peru'),
	PH: i18n.t('Philippines'),
	PN: i18n.t('Pitcairn'),
	PL: i18n.t('Poland'),
	PT: i18n.t('Portugal'),
	PR: i18n.t('Puerto Rico'),
	QA: i18n.t('Qatar'),
	MK: i18n.t('Republic of North Macedonia'),
	RO: i18n.t('Romania'),
	RU: i18n.t('Российская Федерация'),
	RW: i18n.t('Rwanda'),
	RE: i18n.t('Réunion'),
	BL: i18n.t('Saint Barthélemy'),
	SH: i18n.t('Saint Helena, Ascension and Tristan da Cunha'),
	KN: i18n.t('Saint Kitts and Nevis'),
	LC: i18n.t('Saint Lucia'),
	MF: i18n.t('Saint Martin (French part)'),
	PM: i18n.t('Saint Pierre and Miquelon'),
	VC: i18n.t('Saint Vincent and the Grenadines'),
	WS: i18n.t('Samoa'),
	SM: i18n.t('San Marino'),
	ST: i18n.t('Sao Tome and Principe'),
	SA: i18n.t('Saudi Arabia'),
	SN: i18n.t('Senegal'),
	RS: i18n.t('Serbia'),
	SC: i18n.t('Seychelles'),
	SL: i18n.t('Sierra Leone'),
	SG: i18n.t('Singapore'),
	SX: i18n.t('Sint Maarten (Dutch part)'),
	SK: i18n.t('Slovakia'),
	SI: i18n.t('Slovenia'),
	SB: i18n.t('Solomon Islands'),
	SO: i18n.t('Somalia'),
	ZA: i18n.t('South Africa'),
	GS: i18n.t('South Georgia and the South Sandwich Islands'),
	SS: i18n.t('South Sudan'),
	ES: i18n.t('Spain'),
	LK: i18n.t('Sri Lanka'),
	SD: i18n.t('Sudan'),
	SR: i18n.t('Suriname'),
	SJ: i18n.t('Svalbard and Jan Mayen'),
	SE: i18n.t('Sweden'),
	CH: i18n.t('Switzerland'),
	SY: i18n.t('Syrian Arab Republic'),
	TW: i18n.t('Taiwan'),
	TJ: i18n.t('Tajikistan'),
	TZ: i18n.t('Tanzania, United Republic of'),
	TH: i18n.t('Thailand'),
	TL: i18n.t('Timor-Leste'),
	TG: i18n.t('Togo'),
	TK: i18n.t('Tokelau'),
	TO: i18n.t('Tonga'),
	TT: i18n.t('Trinidad and Tobago'),
	TN: i18n.t('Tunisia'),
	TR: i18n.t('Turkey'),
	TM: i18n.t('Turkmenistan'),
	TC: i18n.t('Turks and Caicos Islands (the)'),
	TV: i18n.t('Tuvalu'),
	UG: i18n.t('Uganda'),
	UA: i18n.t('Ukraine'),
	AE: i18n.t(`United Arab Emirates`),
	GB: i18n.t(`United Kingdom of Great Britain and Northern Ireland`),
	UM: i18n.t(`United States Minor Outlying Islands`),
	US: i18n.t('United States of America'),
	UY: i18n.t('Uruguay'),
	UZ: i18n.t('Uzbekistan'),
	VU: i18n.t('Vanuatu'),
	VE: i18n.t(`Venezuela (Bolivarian Republic of)`),
	VN: i18n.t('Viet Nam'),
	VG: i18n.t(`Virgin Islands`),
	VI: i18n.t(`Virgin Islands`),
	WF: i18n.t('Wallis and Futuna'),
	EH: i18n.t('Western Sahara'),
	YE: i18n.t('Yemen'),
	ZM: i18n.t('Zambia'),
	ZW: i18n.t('Zimbabwe'),
	AX: i18n.t('Aland Islands'),
	other: i18n.t('Другая страна'),
});
